import DashboardAbsencesPage from '../../pages/DashboardAbsences';
import { SurveillantLayout } from '../SurveillantLayout';

export default function AbsencesWrapper() {
  return (
    <SurveillantLayout title="Dashboard absences" fullWidth>
      <DashboardAbsencesPage />
    </SurveillantLayout>
  );
}
